export class BuyProductsModal {
  id: string;
  name: string;
  amount: number;
  tax: number;
  qty: number;
  productType: number;
  accessType: number;
  isReoccurred: boolean;
  isQtyFixed: boolean;
  isMonthWise: boolean;
  productPriceNamePeriod: boolean;
  hasValidity: boolean;
  isChecked: boolean = false;
}
